import * as yup from 'yup';
import { NAME_VALIDATION_REGEX } from 'constants/general';

export const stageTwoInputSchema = (emailError, requiredEmail, nameError, requiredName) =>
  yup.object({
    fullname: yup.string().required(requiredName).matches(NAME_VALIDATION_REGEX, nameError),
    email: yup.string().email(emailError).required(requiredEmail),
  });
